import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportSummaryComponent } from './report-summary';
import { ReportDetailComponent } from './report-detail';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Report'
    },
    children: [
      {
        path: 'summary',
        component: ReportSummaryComponent,
        data: { title: 'List' }
      },
      {
        path: 'detail/:id',
        component: ReportDetailComponent,
        data: { title: 'Details' }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/report/report-routing.module.ts